import $axios from "../api.js";

const state = () => ({
  temp: "",
  sender: [],
  auth_data: {
    name: "",
    phone: "",
    pin: "",
    pin_confirmation: "",
    referred_by: "",
    verification_code: "",
    signature_security: "",
  },
  loading: {
    button: false,
    screen: false,
  },
});

const mutations = {
  SET_SENDER(state, payload) {
    state.sender = payload;
  },
  RESET_AUTH_DATA(state) {
    state.auth_data = {
      name: "",
      phone: "",
      pin: "",
      pin_confirmation: "",
      referred_by: "",
      verification_code: "",
      signature_security: "",
    };
  },
  RESET_LOADING(state) {
    state.loading = {
      button: false,
      screen: false,
    };
  },
  RESET_TOAST(state) {
    state.toast = {
      show: false,
      message: "Success",
      tipe: "default",
      top: "",
      position: "top",
    };
  },
};

const actions = {
  getSender({ commit }) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/auth/sender")
        .then((response) => {
          commit("SET_SENDER", response.data.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  validateRegister({ state }) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/register", {
          data: btoa(JSON.stringify(state.auth_data)),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  verifyRegister({ state }) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/register/verify", {
          data: btoa(JSON.stringify(state.auth_data)),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  // ================================
  login({ state }) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/login", {
          data: btoa(JSON.stringify(state.auth_data)),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  loginVerify({ commit, state }) {
    localStorage.setItem("token", null);
    commit("SET_TOKEN", null, { root: true });

    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/login/verify", {
          data: btoa(JSON.stringify(state.auth_data)),
        })
        .then((response) => {
          if (
            response.data.status == true &&
            response.data.code == "ACCOUNT_LOGIN_SUCCESS"
          ) {
            localStorage.setItem("token", response.data.access_token);
            commit("SET_TOKEN", response.data.access_token, { root: true });
            commit("SET_CUSTOMER", response.data.data, { root: true });
          }
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  loginVerifyOtp({ commit }, payload) {
    localStorage.setItem("token", null);
    commit("SET_TOKEN", null, { root: true });

    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/login/verify/otp", {
          data: btoa(JSON.stringify(payload)),
        })
        .then((response) => {
          if (
            response.data.status == true &&
            response.data.code == "ACCOUNT_LOGIN_SUCCESS"
          ) {
            localStorage.setItem("token", response.data.access_token);
            commit("SET_TOKEN", response.data.access_token, { root: true });
            commit("SET_CUSTOMER", response.data.data, { root: true });
          }
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  // ================================
  forgetVerify({ state }, payload) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/forget/verify/" + payload, {
          data: btoa(JSON.stringify(state.auth_data)),
        })
        .then((response) => {
          // console.log(state.sender);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  // ================================
  requestAuthcode({ state }, payload) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/request-authcode", {
          data: btoa(JSON.stringify(payload)),
        })
        .then((response) => {
          console.log(state.temp);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  requestCode({ state }, payload) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/request-code", {
          data: btoa(JSON.stringify(payload)),
        })
        .then((response) => {
          console.log(state.temp);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/auth/logout")
        .then((response) => {
          localStorage.removeItem("token");
          commit("SET_TOKEN", null, { root: true });
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
